import TaxGuruIconButton from "../../components/button/TaxGuruIconButton";
import DownloadIcon from "@mui/icons-material/Download";
import { CircularProgress } from "@mui/material";
import React from "react";
import { useMutation } from "react-query";
import { CoreFrontendNotificationDto } from "@mm-products/java-multima-framework";
import { toast } from "react-toastify";
import { downloadDataRelativeUrl } from "../../utils/axiosUtils";
import TaxGuruTooltip from "../../components/filter/TaxGuruTooltip";
import { useTranslation } from "react-i18next";
import { toastStyles } from "../../TaxGuruStyles";

type MutateVariables = { downloadUrl: string };
export default function NotificationDownloadButton({ notification }: { notification: CoreFrontendNotificationDto }) {
    const { t } = useTranslation();
    const { mutateAsync, isLoading } = useMutation<unknown, unknown, MutateVariables>({
        mutationFn: (variables) => downloadDataRelativeUrl(variables.downloadUrl),
        onError: () => {
            toast.error(t("attachment.attachmentGone"), { style: toastStyles.error });
        },
    });

    if (!notification.downloadUrl) {
        return null;
    }
    return (
        <TaxGuruTooltip title={t("attachment.download")}>
            <TaxGuruIconButton
                disabled={isLoading}
                size="small"
                onClick={() => notification.downloadUrl && mutateAsync({ downloadUrl: notification.downloadUrl })}
            >
                {isLoading && <CircularProgress size="1em" />}
                {!isLoading && <DownloadIcon />}
            </TaxGuruIconButton>
        </TaxGuruTooltip>
    );
}
